/*
 * Copyright (c) 2016-2023 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
export function getA11ySnapshotNodes(node) {
    node.children = node.children ? node.children : [];
    return node.children
        .reduce((prev, next) => [...prev, ...getA11ySnapshotNodes(next)], [node])
        .map(node => {
        delete node.children;
        return node;
    });
}
